import { useSessionValue } from '@portal/appLayer/auth';
import { CartRules } from '@portal/shared/utils/cartRules';
import { useStoreValue } from '@portal/state/hooks/useStore';
import { useEffect, useState } from 'react';

interface CartRuleDiscounts {
  hasDiscount: boolean;
  discountedVariantId?: string;
  isLoading: boolean;
}

const cartRulesInstance = new CartRules();

export const useCartRuleDiscounts = (originalVariantId?: string): CartRuleDiscounts => {
  const [discounts, setDiscounts] = useState<CartRuleDiscounts>({
    hasDiscount: false,
    isLoading: true
  });

  const session = useSessionValue();
  const store = useStoreValue();
  const customerTags = session?.customer?.tags;

  useEffect(() => {
    if (!originalVariantId || !store) {
      setDiscounts({ hasDiscount: false, isLoading: false });
      return;
    }

    const fetchDiscounts = async () => {
      setDiscounts((prev) => ({ ...prev, isLoading: true }));

      try {
        const discountedVariantId = await cartRulesInstance.getDiscountedVariantId(
          store,
          originalVariantId,
          customerTags || undefined
        );

        const hasDiscount = !!discountedVariantId;

        setDiscounts({
          hasDiscount,
          discountedVariantId: discountedVariantId || undefined,
          isLoading: false
        });
      } catch (error) {
        setDiscounts({ hasDiscount: false, isLoading: false });
      }
    };

    fetchDiscounts();
  }, [originalVariantId, store, customerTags]);

  return discounts;
};
